import React from 'react';
import './App.css';
import { BrowserRouter, Routes, Route } from 'react-router-dom';
import Booking from './pages/Booking';
import { useState, useCallback } from 'react';
import AppointmentConfirmation from './pages/AppointmentConfirmation';
import Feedback from './pages/Feedback';
import { Analytics } from '@vercel/analytics/react';
import Index from './pages/Index';

function App() {
  const [serviceData, setServiceData] = useState({});



  const getServiceData = useCallback((data) => {
    setServiceData(data);
  }, [])

  return (
    <BrowserRouter>
      <Routes>
        <Route path="/" element={<Index />} />
        <Route path="/booking" element={<Booking 
          getServiceData={getServiceData} 
        />} />
        <Route path="/confirm" element={<AppointmentConfirmation />} />
        <Route path="/feedback" element={<Feedback />} />
      </Routes>
      <Analytics />
    </BrowserRouter>
  );
}

export default App;
